/**
 * @generated SignedSource<<15fa917074a0b16de75b5c3226ee4380>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RsvpState = "ATTENDING" | "DECLINED" | "MAYBE" | "NOT_RESPONDED" | "%future added value";
export type RsvpStateInput = "ATTENDING" | "DECLINED" | "MAYBE" | "%future added value";
export type RSVPButton_updateEventInvitation_Mutation$variables = {
  id: string;
  rsvpState: RsvpStateInput;
};
export type RSVPButton_updateEventInvitation_Mutation$data = {
  readonly updateEventInvitation: {
    readonly invitationUpdated: {
      readonly event: {
        readonly " $fragmentSpreads": FragmentRefs<"InviteeOverview">;
      };
      readonly id: string;
      readonly rsvp: RsvpState;
    };
  } | null;
};
export type RSVPButton_updateEventInvitation_Mutation = {
  response: RSVPButton_updateEventInvitation_Mutation$data;
  variables: RSVPButton_updateEventInvitation_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rsvpState"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "rsvpState",
        "variableName": "rsvpState"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rsvp",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RSVPButton_updateEventInvitation_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CalendarEventsUpdateInvitationMutationPayload",
        "kind": "LinkedField",
        "name": "updateEventInvitation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EventInvitation",
            "kind": "LinkedField",
            "name": "invitationUpdated",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "InviteeOverview"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RSVPButton_updateEventInvitation_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CalendarEventsUpdateInvitationMutationPayload",
        "kind": "LinkedField",
        "name": "updateEventInvitation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EventInvitation",
            "kind": "LinkedField",
            "name": "invitationUpdated",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventInvitationConnection",
                    "kind": "LinkedField",
                    "name": "invitations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                      },
                      {
                        "alias": "attendingCount",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "rsvpState",
                            "value": "ATTENDING"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": "count(rsvpState:\"ATTENDING\")"
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2637e6d7335e3fe34cc31f5631b5522a",
    "id": null,
    "metadata": {},
    "name": "RSVPButton_updateEventInvitation_Mutation",
    "operationKind": "mutation",
    "text": "mutation RSVPButton_updateEventInvitation_Mutation(\n  $id: ID!\n  $rsvpState: RsvpStateInput!\n) {\n  updateEventInvitation(input: {id: $id, rsvpState: $rsvpState}) {\n    invitationUpdated {\n      id\n      rsvp\n      event {\n        ...InviteeOverview\n        id\n      }\n    }\n  }\n}\n\nfragment InviteeOverview on Event {\n  invitations {\n    count\n    attendingCount: count(rsvpState: ATTENDING)\n  }\n}\n"
  }
};
})();

(node as any).hash = "b3baa204e423b5633d84d8e61a4d8efe";

export default node;
